import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { NOMINATIM_URL } from '@/features/geo-coding/constants/geoCoding';
import type { OsmPlace } from '@/features/geo-coding/types/place';

export const useReverse = (lat?: number, lon?: number) =>
  useQuery({
    queryKey: [API_CACHE_KEYS.GEOCODE_REVERSE, { lat, lon }],
    queryFn: () => fetchReverse(lat!, lon!),
    enabled: lat != undefined && lon != undefined
  });

async function fetchReverse(lat: number, lon: number): Promise<OsmPlace> {
  const url =
    NOMINATIM_URL +
    'reverse?lat=' +
    encodeURIComponent(lat) +
    '&lon=' +
    encodeURIComponent(lon) +
    '&zoom=18&addressdetails=1&format=json&accept-language=de';

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json() as Promise<OsmPlace>;
}
